module.exports = __webpack_public_path__ + "static/media/identity-mapping.25d178f4.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/identity-mapping.md
// module id = 1100
// module chunks = 0